import { render, staticRenderFns } from "./BlueWhatsAppPlus.vue?vue&type=template&id=fb26d096&scoped=true"
import script from "./BlueWhatsAppPlus.vue?vue&type=script&lang=js"
export * from "./BlueWhatsAppPlus.vue?vue&type=script&lang=js"
import style0 from "./BlueWhatsAppPlus.vue?vue&type=style&index=0&id=fb26d096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb26d096",
  null
  
)

export default component.exports